import { useState } from 'react';

import { useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useMutationDeleteTag } from 'api/mutations/deleteTag.mutation';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Settings/Components/Tags/components/tags.module.scss';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';

export const RowOptionsCell = ({ row }) => {
    const { name, tagId } = row.original;
    const [show, setShow] = useState<boolean>(false);
    const history = useHistory();
    const { pathname } = useLocation();
    const { mutate } = useMutationDeleteTag();
    const { customerId } = useUserHook();
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();
    const { project } = useProjectTreeStore();

    const handleEdit = () => {
        history.push(`${pathname}/${settingsConfig.tagsEdit.link}/${tagId}`);
    };

    const handleDelete = () => {
        const { tagId } = row.original;
        if (!customerId || !project) return null;
        mutate(
            {
                tagId,
            },
            {
                onSuccess: () => {
                    handleSnackBar('Successfully deleted!', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    queryClient.invalidateQueries('getStoredTags');
                },
            },
        );
        setShow(false);
    };

    return (
        <div className={classes.actions}>
            <CustomizedRoundIcon onClick={handleEdit}>
                <Icon name={'edit-user-profile'} />
            </CustomizedRoundIcon>

            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <MuiIcon icon={'delete'} type={'outlined'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete tag ${name}?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
